import ReviewsSection from "@/components/ReviewsSection";

export default function ReviewsPage() {
  return (
    <div className="min-h-[60vh]">
      <div className="bg-[#1E1A17] py-16 text-center px-4">
        <h1 className="font-serif text-4xl sm:text-5xl text-white">Customer Reviews</h1>
        <p className="mt-3 text-[#B8AE9C] max-w-2xl mx-auto">Real feedback from homes and short-term rentals across Central Texas.</p>
      </div>
      <ReviewsSection featured={false} showReadMore={false} />
      <div className="text-center py-16" data-testid="reviews-page-cta">
        <a href="/book" className="inline-block bg-[#B87333] text-white rounded-full px-8 py-3 font-medium">Book your cleaning</a>
      </div>
    </div>
  );
}
